import { Link } from '~/components/link';
import { useFolderPath } from '~/contexts';

export const ContentLocation = ({ contentFolderId }: { contentFolderId: number }) => {
  const path = useFolderPath(contentFolderId);
  const joinedPath = path
    .slice(1)
    .map((x) => x.name)
    .join('/');

  return (
    <Link onClick={(e) => e.stopPropagation()} to={`../${contentFolderId}`}>
      /{joinedPath}
    </Link>
  );
};
